<template>
  <component :is="as" class="grid grid-cols-12 gap-4 lg:gap-10" data-component="Grid">
    <slot />
  </component>
</template>

<script setup lang="ts">
export type GridProps = {
  as?: 'div' | 'span' | 'nav' | 'section' | 'article' | 'aside' | 'header' | 'footer' | 'main' | 'dialog' | 'ul'
}

const props = withDefaults(defineProps<GridProps>(), {
  as: 'div',
})
</script>
